import "./index.css";
const n = "_input_balloon_wrap_kuunn_1", o = "_ballon_wrap_kuunn_11", _ = "_ballon_icon_kuunn_15", t = "_dark_kuunn_24", l = "_balloon_overlay_kuunn_27", a = "_balloon_content_kuunn_27", c = "_balloon_content_dark_kuunn_30", b = {
  input_balloon_wrap: n,
  ballon_wrap: o,
  ballon_icon: _,
  dark: t,
  balloon_overlay: l,
  balloon_content: a,
  balloon_content_dark: c
}, e = "_reolink_1a1h5_7", s = "_title_1a1h5_1", r = "_desc_1a1h5_13", u = "_camovue_1a1h5_20", k = "_dark_1a1h5_33", i = {
  "title-with-desc-content": "_title-with-desc-content_1a1h5_1",
  reolink: e,
  title: s,
  desc: r,
  camovue: u,
  dark: k
};
export {
  i as a,
  b as s
};
//# sourceMappingURL=index.extra.js.map
